export default {
  redirectUrl: 'https://school.alphalawyer.cn',
  appKey: 'e0b362c283b69f8c1d0e3b871f9cdc49',
  courseFilesDomain: 'https://school.alphalawyer.cn',
  sensorServerUrl: 'https://shence.alphalawyer.cn/sa?project=production',
  sensorWebUrl: 'https://shenceadmin.alphalawyer.cn?project=production',
  sensorShowLog: false,
}
